module.exports = __webpack_public_path__ + "Verlag-Black.otf?0f6863f88ee91bfe5a83a1363acfbb76";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/verlag/Verlag-Black.otf
// module id = 311
// module chunks = 0